module.exports = __webpack_public_path__ + "img/left.dc571d89.jpeg";